export const defaultInvoiceTextTranslationKeys = {
  footerNote: 'external_invoices.invoice_footer_note.default',
  message: 'external_invoices.invoice_message.default',
} as const
